export const ADD_TILE = "features/Grid/ADD_TILE";
export const REMOVE_TILE = "features/Grid/REMOVE_TILE";
